<template>
  <a
    :href="`${l.path ? l.path : '/' + l.url}`"
    @click.prevent="goto(l)"
    v-for="(l, i) in links"
    :key="i"
    >{{ l.title }}</a
  >
  <NuxtLink to="#contact" @click="emit('close')">Контакты</NuxtLink>

  <a
    :href="formatTel(contacts?.phone)"
    @click="useMetrika('phone')"
    id="phone"
    >{{ formatPhone(contacts?.phone) }}</a
  >
</template>

<script setup>
const emit = defineEmits(["close"]);
const props = defineProps(["isMobile"]);
import { formatPhone, formatTel } from "~/helpers/format";
import { inject } from "vue";
const contacts = inject("contacts");
const links = [
  { title: "Услуги", url: "service" },
  { title: "Производство", path: "/#production" },
  { title: "Проекты", url: "projects" },
  { title: "Новости", url: "news" },
];
const route = useRoute();
const goto = (l) => {
  if (props.isMobile) emit("close");
  if (l.path) return navigateTo(l.path);
  if (route.path != "/") return navigateTo("/" + l.url);
  navigateTo("#" + l.url);
};
</script>
